import '../base';
import '../components/carousels/featured-reviews';
import '../components/media/video-modal';
import '../components/product/reviews-modal';
